import Button from '@ui/buttons/button/button';
import Container from '@ui/container/container';
import Icon from '@ui/icons/icon';
import OptionalComponent from '@ui/optional-component/optional-component';
import RotatableIcon from '@ui/RotatableIcon/rotatable-icon';
import Text from '@ui/text/text/text';
import { ICONS } from '@ui/icons/types';
import Popover from '@ui/popover/popover';
import { useAppSelector } from '@/store/hooks';
import { selectPasscodeListMemberCount } from '@/store/slices/passcode-lists/selectors';

type PasscodeListAttachedProjectsProps = {
  displayAssociatedEvents?: boolean;
  passcodeListAssociatedEvents?: { name: string; uuid: string }[];
  passcodeListDownload?: () => void;
};

const PasscodeListAttachedProjects = ({
  displayAssociatedEvents,
  passcodeListAssociatedEvents,
  passcodeListDownload,
}: PasscodeListAttachedProjectsProps) => {
  const passcodeListMemberCount = useAppSelector(selectPasscodeListMemberCount);

  return (
    <OptionalComponent
      display={displayAssociatedEvents && passcodeListAssociatedEvents && passcodeListAssociatedEvents?.length > 0}
    >
      <Container className="flex fd-row jc-flex-start ai-center margin-t-8" background="transparent" minWidth="400px">
        <Text className="S3 " color="var(--gray-300)" fontSize={12}>
          {`${passcodeListMemberCount} Member${passcodeListMemberCount > 1 ? 's' : ''}`}
        </Text>
        <Text className="S3  padding-l-10" color="var(--gray-300)" fontSize={12}>
          •
        </Text>
        <Popover
          backgroundColor="var(--gray-700)"
          containerClassName="flex fd-column ai-center"
          contentClassName="margin-t-4"
          overflow="visible"
          buttonBgColor="transparent"
          width="400px"
          renderTriggerButton={({ open, closing }) => {
            return (
              <Button
                hoverBackgroundColor="var(--gray-600)"
                outlineOnFocus={false}
                className="text-left padding-v-5 padding-h-10 padding-l-4 width-100-percent flex fd-row jc-center"
              >
                <Text color="var(--gray-100) width-100-percent" className="P2 padding-r-4" fontSize={12}>
                  {`Attached to ${passcodeListAssociatedEvents?.length} Project${passcodeListAssociatedEvents && passcodeListAssociatedEvents?.length > 1 ? 's' : ''}`}
                </Text>

                <RotatableIcon name={ICONS.KEYBOARD_ARROW_DOWN} size={12} rotate={open && !closing ? '180deg' : '0'} />
              </Button>
            );
          }}
        >
          {passcodeListAssociatedEvents?.map((event) => {
            return (
              <Container
                className="flex fd-row jc-space-between ai-center padding-4"
                key={event.uuid}
                background="transparent"
              >
                <Text className="padding-v-5 padding-h-10" width="180px">
                  {event.name}
                </Text>
                <Button
                  className="flex fd-row ai-center jc-center gap-4"
                  width="120px"
                  onClick={passcodeListDownload}
                  backgroundColor="var(--gray-600)"
                  hoverBackgroundColor="var(--gray-500)"
                >
                  <Icon name={ICONS.DOWNLOAD} size={12} />
                  <Text fontSize={'12px'}>Download</Text>
                </Button>
              </Container>
            );
          })}
        </Popover>
      </Container>
    </OptionalComponent>
  );
};

export default PasscodeListAttachedProjects;
